import { observer } from 'mobx-react';
import { autoinject, CardItem, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';

export interface IDisplayVideoPathCardProps {
    readonly loading: boolean;
    readonly videoPath: Mri.WebApi.VideoPath;
}

@autoinject
@observer
export class DisplayVideoPathCard extends React.Component<IDisplayVideoPathCardProps> {
    public render() {
        const { videoPath } = this.props;

        return (
            <StatusCard title="Video Status" loading={this.props.loading}>
                <CardItem label="Video Output State" value={videoPath.videoOutputState} />

                <CardItem label="Video Tx State" value={videoPath.videoTxState} />

                <CardItem label="Video Output X Res" value={videoPath.videoOutputXRes} />

                <CardItem label="Video Output Y Res" value={videoPath.videoOutputYRes} />

                <CardItem label="Video Output FPS" value={videoPath.videoOutputFramesPerSec} />

                <CardItem label="Video Output Pixel Clock" value={videoPath.videoOutputPixelClock} />

                <CardItem label="HDMI Link Quality Channel 1" value={videoPath.hdmiLinkQualityChan1} />

                <CardItem label="HDMI Link Quality Channel 2" value={videoPath.hdmiLinkQualityChan2} />

                <CardItem label="HDMI Link Quality Channel 3" value={videoPath.hdmiLinkQualityChan3} />

                <CardItem label="Ursa Input X Res" value={videoPath.ursaInputXRes} />

                <CardItem label="Ursa Input Y Res" value={videoPath.ursaInputYRes} />
            </StatusCard>
        );
    }
}
